import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import AccessibleIcon from '../../AccessibleIcon'
import styles, { iconTheme, iconColor } from './styles'

const MenuIcon = ({ theme, icon }) => (
  <div className={cx(styles.icon, iconTheme(theme))}>
    <AccessibleIcon icon={icon} color={iconColor(theme)} size={14} />
  </div>
)

MenuIcon.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]).isRequired,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
}

MenuIcon.defaultProps = {
  theme: 'primary',
}

export default MenuIcon
